// © 2026 Holmes Computer Consultants. All rights reserved. -- www.holmesconsultants.com
import data from '../../SourceArt/ComponentAssemblies/printed-markers.json'
/** Exact original marks only: custom artwork with other position, colour or size is preserved. */
export function isPrintedBumperMarker(op:Record<string,unknown>):boolean {
 const c=op['centre']
 if(op['op']!=='neonRing'||!Array.isArray(c)||c.length!==2)return false
 return data.markers.some(m=>Math.abs(Number(c[0])-Number(m[0]))<1e-10&&Math.abs(Number(c[1])-Number(m[1]))<1e-10&&Math.abs(Number(op['radius'])-Number(m[2]))<1e-10&&op['colour']===m[3]&&op['width']===m[4])
}
